import { useEffect, useRef, useState } from "react";

/**
 * Returns true once the element enters (or nears) the viewport.
 * Falls back to immediate visibility when IntersectionObserver is unavailable.
 */
export function useInView({ enabled = true, rootMargin = "200px" } = {}) {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(!enabled);

  useEffect(() => {
    if (!enabled) {
      setIsInView(true);
      return;
    }

    const element = ref.current;
    if (!element) return;

    if (typeof IntersectionObserver === "undefined") {
      setIsInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [enabled, rootMargin]);

  return [ref, isInView];
}
